import { useState, useCallback, useMemo } from 'react';
import { TimelineRecordId } from '../types/types';

export enum TimelineEditorMode {
  VIEW = 'view',
  ADD = 'add',
  EDIT = 'edit',
}

export type TimelineEditorState =
  | { mode: TimelineEditorMode.VIEW }
  | { mode: TimelineEditorMode.ADD; type: string }
  | { mode: TimelineEditorMode.EDIT; id: TimelineRecordId['id']; type: string };

export interface TimelineEditor {
  state: TimelineEditorState;
  openAdd: (type: string) => void;
  openEdit: (id: TimelineRecordId['id'], type: string) => void;
  close: () => void;
}

const VIEW_STATE: TimelineEditorState = { mode: TimelineEditorMode.VIEW };

export const useTimelineEditor = (): TimelineEditor => {
  const [state, setState] = useState<TimelineEditorState>(VIEW_STATE);
  const openAdd = useCallback((type: string) => setState({ mode: TimelineEditorMode.ADD, type }), []);
  const openEdit = useCallback(
    (id: TimelineRecordId['id'], type: string) => setState({ mode: TimelineEditorMode.EDIT, id, type }),
    [],
  );
  const close = useCallback(() => setState(VIEW_STATE), []);
  const editor = useMemo(() => ({ state, openAdd, openEdit, close }), [close, openAdd, openEdit, state]);

  return editor;
};
